module.exports = __webpack_public_path__ + "static/media/Lens-Radiant Sweet.b1f24b1e.png";